<template>
  <div class="page">
    <company-box />
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">申请合作</h2>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells__title">
            您想成为<strong>{{ partner.name }}</strong
            >的
          </div>
          <div class="weui-cells weui-cells_radio">
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x11"
            >
              <div class="weui-cell__bd">
                <p>供应商</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  class="weui-check"
                  v-model="identity"
                  value="1"
                  checked="checked"
                  id="x11"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x12"
            >
              <div class="weui-cell__bd">
                <p>客户</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  v-model="identity"
                  value="2"
                  class="weui-check"
                  id="x12"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x13"
            >
              <div class="weui-cell__bd">
                <p>服务商</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  v-model="identity"
                  value="4"
                  class="weui-check"
                  id="x13"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x14"
            >
              <div class="weui-cell__bd">
                <p>代理商</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  v-model="identity"
                  value="8"
                  class="weui-check"
                  id="x14"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div class="weui-form__opr-area opr-block">
        <a class="weui-btn weui-btn__auto weui-btn_primary" @click="apply"
          >确定</a
        >
      </div>

      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__links">
            <a class="weui-footer__link" @click="redirectApp">进入云系统</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyBox from "@/components/CompanyBox";

export default {
  components: {
    CompanyBox
  },
  data() {
    return {
      identity: 1,
      partner: {
        name: null,
      },
      partnerUser: null,
      authData: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.partner = to.params.partner;
      vm.partnerUser = to.params.partnerUser;
      vm.authData = to.params.authData;
    });
  },
  methods: {
    apply() {
      var me = this;
      me.$ajax({
        url: "/api/account/company_partner/apply",
        params: {
          enuu: me.partner.enuu,
          userUU: me.partnerUser,
          identity: me.identity,
        },
      }).then(function (res) {
        if (res.success) {
          me.$weui.alert("申请成功，请耐心等待对方的回复", {
            title: "提示",
            buttons: [
              {
                label: "知道了",
                type: "primary",
                onClick: function () {
                  me.redirectApp();
                },
              },
            ],
          });
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    redirectApp() {
      this.$router.push("/" + this.authData.appId.replace("-app", ""));
    },
  },
};
</script>

<style scoped>
.opr-block {
  padding: 0 32px;
}
</style>